import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import api from "../lib/api";
import { Gift, Loader2, CheckCircle2, XCircle } from "lucide-react";

const GOLD = "#C9A24B", CREAM = "#F6F3EC", INK = "#1C1A17";
const eur = (n) => `€${Number(n || 0).toFixed(2).replace(".", ",")}`;
const dIt = (s) => { if (!s) return "—"; try { return new Date(s).toLocaleDateString("it-IT", { timeZone: "Europe/Rome" }); } catch { return "—"; } };

export default function ClubVoucher() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    document.title = "Il mio buono · Club Dogana";
    api.get(`/public/club/voucher/${token}`).then(({ data }) => setD(data)).catch(() => setErr(true));
  }, [token]);

  const voucherUrl = `${window.location.origin}/club/voucher/${token}`;
  const active = d?.status === "ACTIVE";
  const redeemed = d?.status === "REDEEMED";
  const expired = d?.status === "EXPIRED" || d?.status === "CANCELLED";

  return (
    <div className="min-h-screen" style={{ backgroundColor: active ? INK : CREAM, fontFamily: "'Outfit', sans-serif" }} data-testid="club-voucher-page">
      <div className="max-w-md mx-auto px-5 py-10">
        <div className="flex flex-col items-center text-center">
          <div className="flex items-center gap-1.5 text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: GOLD }}><Gift className="w-4 h-4" /> Club Dogana</div>
        </div>
        {err ? (
          <p className="mt-10 text-center text-black/60">Buono non trovato.</p>
        ) : !d ? (
          <div className="mt-10 flex justify-center" style={{ color: GOLD }}><Loader2 className="w-6 h-6 animate-spin" /></div>
        ) : (
          <>
            <p className="mt-8 text-center text-xs uppercase tracking-widest font-semibold" style={{ color: GOLD }}>Il tuo buono</p>
            <div className="text-center text-6xl font-extrabold mt-1" style={{ color: active ? CREAM : INK }} data-testid="voucher-amount">{eur(d.amount)}</div>

            {active && (
              <>
                <p className="mt-4 text-center text-sm" style={{ color: CREAM }}>Valido fino al <strong style={{ color: GOLD }}>{dIt(d.expires_at)}</strong></p>
                <p className="mt-1 text-center text-sm" style={{ color: "rgba(246,243,236,0.7)" }}>Codice: <strong style={{ color: CREAM }}>{d.voucher_code}</strong></p>
                <div className="mt-6 mx-auto w-fit bg-white p-4 rounded-2xl" data-testid="voucher-qr">
                  <QRCodeCanvas value={voucherUrl} size={640} level="M" style={{ width: 220, height: 220 }} />
                </div>
                <p className="mt-5 text-center text-sm" style={{ color: "rgba(246,243,236,0.85)" }}>Mostra questo QR alla cassa alla tua prossima visita.</p>
                <div className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full py-2 text-sm font-semibold" style={{ backgroundColor: GOLD, color: INK }}>ATTIVO</div>
              </>
            )}

            {redeemed && (
              <div className="mt-6 rounded-2xl bg-white border border-black/10 p-6 text-center">
                <CheckCircle2 className="w-10 h-10 mx-auto" style={{ color: "#2e7d32" }} />
                <p className="mt-3 text-lg font-bold" style={{ color: INK }}>Buono utilizzato</p>
                <p className="mt-1 text-sm text-black/60">Utilizzato il {dIt(d.redeemed_at)}</p>
                <p className="mt-1 text-xs text-black/40">{d.voucher_code}</p>
              </div>
            )}

            {expired && (
              <div className="mt-6 rounded-2xl bg-white border border-black/10 p-6 text-center">
                <XCircle className="w-10 h-10 mx-auto text-black/30" />
                <p className="mt-3 text-lg font-bold" style={{ color: INK }}>{d.status === "CANCELLED" ? "Buono annullato" : "Questo buono è scaduto"}</p>
                {d.status !== "CANCELLED" && <p className="mt-1 text-sm text-black/60">Scaduto il {dIt(d.expired_at || d.expires_at)}</p>}
                <p className="mt-1 text-xs text-black/40">{d.voucher_code}</p>
              </div>
            )}

            <p className="mt-8 text-center text-xs" style={{ color: active ? "rgba(246,243,236,0.4)" : "rgba(0,0,0,0.4)" }}>Pagina di sola consultazione. Il buono viene convalidato dal personale alla cassa.</p>
          </>
        )}
      </div>
    </div>
  );
}
